import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box
} from "@mui/material";

/**
 * Generic modal for visualizing data.
 * Can be reused across pages by injecting a visualization component (e.g., MemberDetailsCard).
 */
const DataVisualizationModal = ({ open, onClose, title, children, onEdit }) => {
  const filterChildren = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      const filteredProps = {
        ...child.props,
        socio: Object.fromEntries(
          Object.entries(child.props.socio || {}).filter(
            ([key]) => key.toUpperCase() !== "ID" && key.toUpperCase() !== "FIREBASEID"
          )
        )
      };
      return React.cloneElement(child, filteredProps);
    }
    return child;
  });

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection="column" gap={2} width="100%">
          <Box width="100%" maxWidth="600px" mx="auto" sx={{ '& .MuiTextField-root': { width: '100%' } }}>
            {filterChildren}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        {onEdit && (
          <Button onClick={onEdit} variant="outlined" color="primary">
            Editar
          </Button>
        )}
        <Button onClick={onClose} variant="contained" color="primary">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DataVisualizationModal;